import { Logger } from '@main/utils/logger';
import type { ShowAgentListEventPublisher } from './show-agentlist.usecase';

export class ShowAgentListPublisher implements ShowAgentListEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(): Promise<void> {
    this.logger.info('ShowAgentListPublisher:', {
      action: 'ShowAgentListPublisher',
    });
  }
}
